import { toaster } from './toast/ToastContainerParkUi'

export type ToastMessage =
    | string
    | {
        title: string
        message?: string
        duration?: number
    }

function parseMessage(message: ToastMessage) {
    if (typeof message === 'string') {
        return { title: message, description: undefined, duration: 5000 }
    }
    return { title: message.title, description: message.message, duration: message.duration || 5000 }
}

export function toastOnSuccess(message: ToastMessage) {
    const { title, description, duration } = parseMessage(message)
    return toaster.success({
        title,
        description,
        type: 'success',
        duration,
    })
}

export function toastOnError(message: ToastMessage) {
    const { title, description, duration } = parseMessage(message)
    return toaster.error({
        title,
        description,
        type: 'error',
        duration,
    })
}

export function toastOnWarn(message: ToastMessage) {
    const { title, description, duration } = parseMessage(message)
    return toaster.warning({
        title,
        description,
        type: 'warning',
        duration,
    })
}

export function toastOnInfo(message: ToastMessage) {
    const { title, description, duration } = parseMessage(message)
    return toaster.info({
        title,
        description,
        type: 'info',
        duration,
    })
}

export function toastOnCustom(message: ToastMessage) {
    const { title, description, duration } = parseMessage(message)
    return toaster.create({
        title,
        description,
        type: 'neutral',
        duration,
    })
}
